/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Monitoring API
 * A comprehensive portfolio monitoring and reporting tool for DeFi users to track investments/balances across multiple protocols, discover yield opportunities, and generate reports for tax and accounting purposes.  The API enables users to: - Monitor balances and earnings across lending, liquid staking, LP positions, vaults, and traditional staking - Discover new yield opportunities with advanced filtering and sorting - Generate downloadable reports for taxes, accounting, and personal tracking - Aggregate data at multiple levels (combined, by category, by protocol, by wallet) - Track performance over time with historical data
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * ChainsApi - axios parameter creator
 */
export const ChainsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves metadata about blockchain networks, such as the chain name, CAIP-2 identifier, network type (mainnet, testnet, or devnet), chain icon URI, estimated block time, required block confirmations, RPC gateways, native currency details, and block explorer URLs. This information is useful for displaying chain details and configuring interactions with different blockchains.
         * @summary Get blockchain network metadata
         * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
         * @param {string} [chainName] The name of a blockchain.
         * @param {NetworkType} [networkType] The type of network (mainnet, testnet, or devnet).
         * @param {ChainType} [chainType] The type of chain (e.g evm, or aptos).
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChains: async (chainID, chainName, networkType, chainType, fiatType, options = {}) => {
            const localVarPath = `/portfolio/v1/chains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (chainID !== undefined) {
                localVarQueryParameter['chainID'] = chainID;
            }
            if (chainName !== undefined) {
                localVarQueryParameter['chainName'] = chainName;
            }
            if (networkType !== undefined) {
                localVarQueryParameter['networkType'] = networkType;
            }
            if (chainType !== undefined) {
                localVarQueryParameter['chainType'] = chainType;
            }
            if (fiatType) {
                localVarQueryParameter['fiatType'] = fiatType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ChainsApi - functional programming interface
 */
export const ChainsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ChainsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves metadata about blockchain networks, such as the chain name, CAIP-2 identifier, network type (mainnet, testnet, or devnet), chain icon URI, estimated block time, required block confirmations, RPC gateways, native currency details, and block explorer URLs. This information is useful for displaying chain details and configuring interactions with different blockchains.
         * @summary Get blockchain network metadata
         * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
         * @param {string} [chainName] The name of a blockchain.
         * @param {NetworkType} [networkType] The type of network (mainnet, testnet, or devnet).
         * @param {ChainType} [chainType] The type of chain (e.g evm, or aptos).
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChains(chainID, chainName, networkType, chainType, fiatType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChains(chainID, chainName, networkType, chainType, fiatType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChainsApi.getChains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ChainsApi - factory interface
 */
export const ChainsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ChainsApiFp(configuration);
    return {
        /**
         * Retrieves metadata about blockchain networks, such as the chain name, CAIP-2 identifier, network type (mainnet, testnet, or devnet), chain icon URI, estimated block time, required block confirmations, RPC gateways, native currency details, and block explorer URLs. This information is useful for displaying chain details and configuring interactions with different blockchains.
         * @summary Get blockchain network metadata
         * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
         * @param {string} [chainName] The name of a blockchain.
         * @param {NetworkType} [networkType] The type of network (mainnet, testnet, or devnet).
         * @param {ChainType} [chainType] The type of chain (e.g evm, or aptos).
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChains(chainID, chainName, networkType, chainType, fiatType, options) {
            return localVarFp.getChains(chainID, chainName, networkType, chainType, fiatType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChainsApi - object-oriented interface
 */
export class ChainsApi extends BaseAPI {
    /**
     * Retrieves metadata about blockchain networks, such as the chain name, CAIP-2 identifier, network type (mainnet, testnet, or devnet), chain icon URI, estimated block time, required block confirmations, RPC gateways, native currency details, and block explorer URLs. This information is useful for displaying chain details and configuring interactions with different blockchains.
     * @summary Get blockchain network metadata
     * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
     * @param {string} [chainName] The name of a blockchain.
     * @param {NetworkType} [networkType] The type of network (mainnet, testnet, or devnet).
     * @param {ChainType} [chainType] The type of chain (e.g evm, or aptos).
     * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChains(chainID, chainName, networkType, chainType, fiatType, options) {
        return ChainsApiFp(this.configuration).getChains(chainID, chainName, networkType, chainType, fiatType, options).then((request) => request(this.axios, this.basePath));
    }
}
